import Components from '@/shared/components'
import Errors from '@/shared/errors'
import Hooks from '@/shared/hooks'
import States from '@/shared/states'
import Utils from '@/shared/utils'

const Shared = {
  Components,
  Utils,
  Hooks,
  Errors,
  States
}

export default Shared
